// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @ components
const MortgageRequestMovingExpensesSummary = require('components/mortgageRequest/mortgageRequestMovingExpensesSummary/mortgageRequestMovingExpensesSummary')

// @actions
const mortgateRequestMovingExpensesAction = require('actions/mortgageRequest/mortgageRequestMovingExpenses');
const mortgageRequestConditionsActions = require('actions/mortgageRequest/mortgageRequestConditions');

class MortgageRequestMovingExpensesSummaryView extends React.Component {
    constructor(props) {
        super(props);

        this.handleRequestMontlyFee = this.handleRequestMontlyFee.bind(this);
    }

    componentDidMount() {
        const { requestConditions } = this.props;
        requestConditions()
    }

    handleRequestMontlyFee(movingExpenses) {
        this.props.requestMonthlyFee(movingExpenses);
    }

    render() {
        const { mortgageRequestMortgageData, mortgageRequestMovingExpensesData, immGlobalPosition, mortgageRequestConditionsState } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestMovingExpenses-breadcrumbName'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        let content;

        if (mortgageRequestMortgageData.get('isFetching') || !mortgageRequestMortgageData.get('req') || mortgageRequestConditionsState.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = (
                <MortgageRequestMovingExpensesSummary
                    mortgageRequestMortgageData={mortgageRequestMortgageData}
                    mortgageRequestMovingExpensesData={mortgageRequestMovingExpensesData}
                    onRequestMontlyFee={this.handleRequestMontlyFee}
                    mortgageRequestConditionsState={mortgageRequestConditionsState}
                />
            );
        }

        return (
            <div className="grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestMovingExpenses-summaryBanner')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestMovingExpensesSummaryView.propTypes = {
    mortgageRequestMortgageData: PropTypes.object,
    mortgageRequestMovingExpensesData: PropTypes.object,
    requestMonthlyFee: PropTypes.func.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    requestConditions: PropTypes.func,
    mortgageRequestConditionsState: PropTypes.object,
}

module.exports.MortgageRequestMovingExpensesSummaryView = connect(
    state => ({
        mortgageRequestMortgageData: state.mortgageRequestMortgageData,
        mortgageRequestMovingExpensesData: state.mortgageRequestMovingExpenses,
        mortgageRequestConditionsState: state.mortgageRequestConditions,
        immGlobalPosition: state.globalPosition,
    }), {
        requestMonthlyFee: mortgateRequestMovingExpensesAction.requestMonthlyFee,
        requestConditions: mortgageRequestConditionsActions.requestConditions
    }
)(MortgageRequestMovingExpensesSummaryView);
